import React from "react";
import { Question, QuestionFactory, Serializer } from "survey-core";
import {
  ReactQuestionFactory,
  SurveyQuestionElementBase,
} from "survey-react-ui";

const QUESTION_TYPE = "ageDateRange";

let isRegistered = false;

class QuestionAgeDateRangeModel extends Question {
  getType() {
    return QUESTION_TYPE;
  }

  get from() {
    return (this.value && this.value.from) || "";
  }

  set from(val) {
    this.setDateRange({ from: val });
  }

  get to() {
    return (this.value && this.value.to) || "";
  }

  set to(val) {
    this.setDateRange({ to: val });
  }

  get fromLabel() {
    return this.getPropertyValue("fromLabel", "From");
  }

  set fromLabel(val) {
    this.setPropertyValue("fromLabel", val);
  }

  get toLabel() {
    return this.getPropertyValue("toLabel", "To");
  }

  set toLabel(val) {
    this.setPropertyValue("toLabel", val);
  }

  get minDate() {
    return this.getPropertyValue("minDate", "");
  }

  set minDate(val) {
    this.setPropertyValue("minDate", val);
  }

  get maxDate() {
    return this.getPropertyValue("maxDate", "");
  }

  set maxDate(val) {
    this.setPropertyValue("maxDate", val);
  }

  setDateRange(partial) {
    const next = {
      from: this.from,
      to: this.to,
      ...partial,
    };

    // When both are empty, clear the answer completely.
    if (!next.from && !next.to) {
      this.value = null;
      return;
    }

    this.value = next;
  }
}

class SurveyQuestionAgeDateRange extends SurveyQuestionElementBase {
  get question() {
    return this.props.question;
  }

  handleFromChange = (e) => {
    this.question.from = e.target.value;
  };

  handleToChange = (e) => {
    this.question.to = e.target.value;
  };

  // renderElement() {
  //   const q = this.question;

  //   const minDate = q.minDate || "";
  //   const maxDate = q.maxDate || "";
  //   const fromMax = q.to || maxDate;
  //   const toMin = q.from || minDate;

  //   // Try to reuse SurveyJS input styling if present.
  //   const inputClassName = [q.cssClasses?.text, q.cssClasses?.textInput]
  //     .filter(Boolean)
  //     .join(" ");

  //   return (
  //     <div className="age-date-range-root-container">
  //       <label style={{ display: "flex", flexDirection: "column", gap: 6 }}>
  //         <span>{q.fromLabel}</span>
  //         <input
  //           className={inputClassName}
  //           type="date"
  //           value={q.from}
  //           min={minDate || undefined}
  //           max={fromMax || undefined}
  //           onChange={this.handleFromChange}
  //         />
  //       </label>

  //       <label style={{ display: "flex", flexDirection: "column", gap: 6 }}>
  //         <span>{q.toLabel}</span>
  //         <input
  //           className={inputClassName}
  //           type="date"
  //           value={q.to}
  //           min={toMin || undefined}
  //           max={maxDate || undefined}
  //           onChange={this.handleToChange}
  //         />
  //       </label>
  //     </div>
  //   );
  // }
  renderElement() {
    const q = this.question;

    const minDate = q.minDate || "";
    const maxDate = q.maxDate || "";
    const fromMax = q.to || maxDate;
    const toMin = q.from || minDate;

    const inputClassName = [q.cssClasses?.text, q.cssClasses?.textInput]
      .filter(Boolean)
      .join(" ");

    return (
      <div
        className="age-date-range-root-container"
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "12px",
          width: "100%",
        }}
      >
        {/* FROM */}
        <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
          <label className="sv-question__label">{q.fromLabel}</label>
          <input
            type="date"
            disabled={q.isReadOnly}
            readOnly={q.isReadOnly}
            className={inputClassName}
            value={q.from}
            min={minDate || undefined}
            max={fromMax || undefined}
            onChange={this.handleFromChange}
            style={{ width: "100%" }}
          />
        </div>

        {/* TO */}
        <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
          <label className="sv-question__label">{q.toLabel}</label>
          <input
            type="date"
            disabled={q.isReadOnly}
            readOnly={q.isReadOnly}
            className={inputClassName}
            value={q.to}
            min={toMin || undefined}
            max={maxDate || undefined}
            onChange={this.handleToChange}
            style={{ width: "100%" }}
          />
        </div>
      </div>
    );
  }
}

export function registerAgeDateRangeQuestion() {
  if (isRegistered) return;
  isRegistered = true;

  Serializer.addClass(
    QUESTION_TYPE,
    [
      {
        name: "name",
        type: "text",
        category: "general",
        visible: true,
        isRequired: true,
        isLocalizable: false,
        onSetValue: function (obj, value) {
          obj.setPropertyValue("name", value);
        },
        onGetValue: function (obj) {
          return obj.getPropertyValue("name");
        },
      },
      { name: "fromLabel:text", category: "general", default: "From" },
      { name: "toLabel:text", category: "general", default: "To" },
      {
        name: "minDate:text",
        category: "general",
        default: "",
        displayName: "Min Date (YYYY-MM-DD)",
      },
      {
        name: "maxDate:text",
        category: "general",
        default: "",
        displayName: "Max Date (YYYY-MM-DD)",
      },
    ],
    () => new QuestionAgeDateRangeModel(""),
    "question",
  );

  QuestionFactory.Instance.registerQuestion(
    QUESTION_TYPE,
    (name) => new QuestionAgeDateRangeModel(name),
  );

  ReactQuestionFactory.Instance.registerQuestion(QUESTION_TYPE, (props) => {
    return React.createElement(SurveyQuestionAgeDateRange, props);
  });
}

// Auto-register on import (convenient for SurveyBuilder usage).
registerAgeDateRangeQuestion();
